import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorPage from "./pages/error/ErrorPage";
import MainScreen, {
  loader as rootLoader,
} from "./pages/mainScreen/MainScreen";
import Customer, {
  loader as costumerLoader,
  action as costumerAction,
} from "./pages/consumer/Costumer";
import CostumerList from "./pages/costumerList/CostumerList";
import Login, { action as loginAction } from "./pages/login/Login";
import { Provider } from "react-redux";
import store from "./store/store";
import ProtectedRoute from "./route/ProtectedRoute";
import CustomerCreate, {
  action as createAction,
} from "./pages/createCostumer/CostumerCreate";

const router = createBrowserRouter([
  {
    path: "/",
    loader: rootLoader,
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <MainScreen />,
        children: [
          {
            path: "/",
            element: <CostumerList />,
          },
          {
            path: "costumer/get/:id",
            element: <Customer />,
            loader: costumerLoader,
            action: costumerAction,
          },
          {
            path: "costumer/create",
            element: <CustomerCreate />,
            action: createAction,
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    action: loginAction,
    element: <Login />,
    errorElement: <ErrorPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);
